import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import {
  resultPostprocessing2,
} from "@/components/fetcher/fetchInterceptor"
import { BlockUser } from "@/app/entities/BFF/BlockUser"

const ROOT = process.env.NEXT_PUBLIC_ROOT

const fetchClientMyBlockUsers = async () =>
  fetchInterceptorInClient(
    {
      method: "get",
      credentials: "same-origin",
    },
    ROOT,
  )(() => `/api/community/user-block/profiles/blocked`, { size: 999 }).then(
    resultPostprocessing2<BlockUser[]>,
  )

export default fetchClientMyBlockUsers
